import $ from 'jquery';
import {Easings, smoothy} from "smoothy";

function scrollToHash(hash) {
    if (hash === '') {
        return false;
    }
    let $target;
    if (hash === '#') {
        $target = $(document.body);
    } else {
        $target = $(hash);
    }
    if ($target.length === 0) {
        return false;
    }
    let oldId = $target.attr('id');
    $target.removeAttr('id');
    smoothy(() => $target.offset().top, 1000, Easings.easeOutQuint).then(() => {
        $target.attr('id', oldId);
    });
    return true;
}

if (window.location.hash) {
    scrollToHash(window.location.hash);
}

// links with .no-scroll are ignored.
$('a[href*="#"]:not(.no-scroll)').on('click', function (e) {
    if (
        this.protocol === window.location.protocol
        && this.host === window.location.host
        && this.pathname === window.location.pathname
    ) {
        if (scrollToHash(this.hash)) {
            e.preventDefault();
        }
    }
});
